import { Component, HostListener, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { VehicleService } from "../../vdms/vdms_core/services/api/vehicle.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DataService } from "../../vdms/vdms_core/services/vehicle/vehicle.data.services";
import { FuelcardService } from "../../vdms/vdms_core/services/api/fuelcard.service";
import { Router } from "@angular/router";
import { HttpErrorResponse } from "@angular/common/http";
import { CryptoService } from "../../vdms/vdms_core/services/api/crypto/crypto.service";

@Component({
  selector: "app-assigned-car",
  templateUrl: "./assigned-car.component.html",
  styleUrls: ["./assigned-car.component.css"],
})
export class AssignedCarComponent implements OnInit {
  displayCarValue: Number = 0;
  assignCarlist: any = [];
  emp_Data: any = [];
  car_modal: any = [];
  assigncarFm: FormGroup;
  submitted = false;
  carMaster: any = [];
  mode: any;
  isValid: any = true;
  errorMessage: any;
  statusData: any = [
    { id: 1, name: "ASSIGN" },
    { id: 2, name: "UNASSIGN" },
  ];
  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;

  noOfItems = 10;
  emp_assigned_cars: any;

  carTypeData: any = [
    { id: 1, name: "Office Car" },
    { id: 2, name: "Family Car" },
    { id: 3, name: "Others" },
  ];

  receivedAllVehicleRecord: any
  unAssignedCarData: any;
  helperunAssignedCarData: any;
  pagenationNextToken = "";
  isnextBtn: boolean = false;

  isEditModeStatus: boolean = false;
  isViewModeStatus: boolean = false
  isSurrenderModeStatus: boolean = false

  receivedAllFuelCardRecord: any = [];
  unassignCardData: any = [];
  helperunassignCardData: any = [];

  searchInput: FormControl = new FormControl();
  isDropdownVisible: boolean = false;

  fuelCardsearchInput: FormControl = new FormControl();
  isFuelCardDropdownVisible: boolean = false;

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder,
    public vehicleService: VehicleService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dataService: DataService,
    private fuelCardService: FuelcardService,
    private router: Router,
    private criptoService: CryptoService
  ) {
    // this.mode = "";
    // this.getAllData();
    this.getAllVehicle();
  }


  // Initialize or patch form based on mode
  checkInit() {
    const existingData = this.dataService.getRecord();

    if (existingData) {
      const mode = existingData.mode;
      switch (mode) {
        case 'isEditMode':
          this.isEditModeStatus = true;
          this.editData(existingData);
          break;
        case 'isViewMode':
          this.isViewModeStatus = true;
          this.editData(existingData);
          this.assigncarFm.disable(); // Disable form for view mode
          break;
        case 'isSurrenderMode':
          this.isSurrenderModeStatus = true;
          this.editData(existingData);
          //  this.vehicleForm.disable(); // Disable form for surrender mode
          break;
        default:
          this.formInitilization(); // Create mode
      }
    } else {
      this.formInitilization(); // Create mode if no data found
    }

    this.dataService.clearRecord();
  }

  async getAllVehicle() {
    console.log("Fetching car maintenance data...");
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: string = null;  // Start with null for the first page
    this.receivedAllVehicleRecord = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.vehicleService.getAllVehicleMaster(nextToken, limit));
        console.log("Fetched Page Data:", data);

        // Append the fetched records to tempData
        this.receivedAllVehicleRecord = [...this.receivedAllVehicleRecord, ...data.items];
        console.log(`Total records fetched so far: ${this.receivedAllVehicleRecord.length}`);

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;
        console.log("Next Token:", nextToken);

      } while (nextToken !== null);  // Continue as long as there's a nextToken

      console.log("All records fetched All vehicle:", typeof this.receivedAllVehicleRecord, this.receivedAllVehicleRecord);

      // After fetching all records, process the data
      // After fetching all records, process the data
      this.splitRecordsByStatus();


    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }


  splitRecordsByStatus() {

    var statusArray = ['ASSIGN', 'UNASSIGN', 'VIP', 'SURRENDER'];

    // Initialize an object to hold arrays for each status
    // Initialize the object to hold arrays for each status
    const splitRecords = {};

    // Initialize each status in splitRecords with an empty array
    for (const status of statusArray) {
      splitRecords[status] = []; // Create an empty array for each status
    }

    // Categorize vehicles based on ex_data
    for (const vehicle of this.receivedAllVehicleRecord) {
      if (splitRecords[vehicle.ex_data]) {
        splitRecords[vehicle.ex_data].push(vehicle); // Push vehicle into the corresponding status array
      }
    }
    console.log('GET_ALL_Vehicle_splitRecords', splitRecords);

    // Store specific records for "ASSIGN" and "UNASSIGN"

    // this.assignedCarData = splitRecords['ASSIGN'] || [];
    this.helperunAssignedCarData = splitRecords['UNASSIGN'] || [];
    this.unAssignedCarData = splitRecords['UNASSIGN'] || [];
    // this.surrenderedData = splitRecords['SURRENDER'] || [];
    // this.vipData = splitRecords['VIP'] || [];

    console.log('AssignedCarData', this.unAssignedCarData)

    if (this.unAssignedCarData.length > 0) {

      // this.getUserType();
    }
    this.spinnerService.hide();

    this.getAllFuelCard()

    return splitRecords;

  }

  async getAllFuelCard() {
    const limit = 100;  // Set the limit for records per request
    let nextToken: any = null;  // Start with null for the first page
    this.receivedAllFuelCardRecord = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.fuelCardService.getAllFuelCardMaster(nextToken, limit));
        console.log("Fetched Page Data:", data);

        // Append the fetched records to tempData
        this.receivedAllFuelCardRecord = [...this.receivedAllFuelCardRecord, ...data.items];
        console.log(`Total records fetched so far: ${this.receivedAllFuelCardRecord.length}`);

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;
        console.log("Next Token:", nextToken);

      } while (nextToken !== null);  // Continue as long as there's a nextToken

      console.log("All records fetched:", typeof this.receivedAllFuelCardRecord, this.receivedAllFuelCardRecord);

      // After fetching all records, process the data
      // After fetching all records, process the data
      this.splitFuelRecordsByStatus();


    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }

  }

  splitFuelRecordsByStatus() {

    var statusArray = ['ASSIGN', 'UNASSIGN', 'INACTIVE'];

    // Initialize an object to hold arrays for each status
    // Initialize the object to hold arrays for each status
    const splitRecords = {};

    // Initialize each status in splitRecords with an empty array
    for (const status of statusArray) {
      splitRecords[status] = []; // Create an empty array for each status
    }

    // Categorize vehicles based on ex_data
    for (const vehicle of this.receivedAllFuelCardRecord) {
      if (splitRecords[vehicle.status]) {
        splitRecords[vehicle.status].push(vehicle); // Push vehicle into the corresponding status array
      }
    }

    this.helperunassignCardData = splitRecords['UNASSIGN'] || [];
    this.unassignCardData = JSON.parse(JSON.stringify(this.helperunassignCardData));

    this.spinnerService.hide();
    return splitRecords;

  }




  // GET CAR MASTER FOR DROPDOWN
  getAllCarData() {
    console.log("master_car");
    this.awserviceProvider.filterRnCar().then((data) => {
      console.log("Unassigned car list", data);
      this.carMaster = data;
      console.log("Unassigned car list", this.carMaster);
    });
  }

  // GET DATA FROM ASSIGNED CARS
  getAllData() {
    console.log("GET CAR LIST");
    this.awserviceProvider.getAssignCarList().then((data) => {
      // this.assignCarlist = data;
      // console.log("response", data);
      this.constructData(data.filter((res) => res.status === "ASSIGN"));
      console.log("assignCarlist", this.assignCarlist);
    });
  }

  // constructData(data) {
  //   for (var i in data) {
  //     data[i].sno = +i + 1;
  //     this.openStatus(data[i].car_id, data, i);
  //   }
  // }

  // Search RN
  searchRnId() {
    console.log('searchRNID_function')
    this.rnIdSearch();
    // this.emp_assigned_cars = [];
    // if (this.assigncarFm.value.rn_num !== "") {
    //   console.log('Search_ID',this.assigncarFm.value.rn_num)
    //   this.awserviceProvider
    //     .filterRnExistCar(this.assigncarFm.value.rn_num)
    //     .then((result) => {
    //       console.log("CarRnExist", result);
    //       // if (result.length === 0) {
    //       this.rnIdSearch();
    //       this.emp_assigned_cars = result;
    //       console.log("Emp Assigned Car Details: ", this.emp_assigned_cars);
    //       this.getEmpCarDetails();
    //       this.isValid = false;
    //       console.log("Emp Assigned Car Details: ", this.emp_assigned_cars);
    //       /* } else {
    //         this.emp_Data = [];
    //         this.isValid = true;
    //         this.errorMessage = "User already Exists!";
    //       } */
    //     })
    //     .catch((err) => {
    //       console.log("err", err);
    //     });
    // } else {
    //   this.errorMessage = "Please Enter RN Number...";
    // }
  }



  async getVehicelAssignedCar(rnID: string) {
    console.log("Fetching car maintenance data...");
    // alert('carRequest' + this.carReqlist.length)
    const limit = 100;  // Set the limit for records per request
    let nextToken: string = null;  // Start with null for the first page
    this.emp_assigned_cars = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop until nextToken becomes null (no more pages)
      do {
        // Fetch data from API, starting with null nextToken for the first page
        const data = (await this.vehicleService.filterByAssignedCarBasedonRnID(nextToken, limit, rnID));
        console.log("Fetched Page Data:", data);

        // Append the fetched records to tempData
        this.emp_assigned_cars = [...this.emp_assigned_cars, ...data.items];
        console.log(`Total records fetched so far: ${this.emp_assigned_cars.length}`);

        // Update nextToken for the next iteration (will be null if no more pages)
        nextToken = data.nextToken;
        console.log("Next Token:", nextToken);

      } while (nextToken !== null);  // Continue as long as there's a nextToken

      console.log("All records fetched All Assigned vehicle by user:", typeof this.emp_assigned_cars, this.emp_assigned_cars);

      // After fetching all records, process the data
      // After fetching all records, process the data
      // this.splitRecordsByStatus();

      if (this.emp_assigned_cars.length > 0) {
        this.getVehicleByCarID()
      }


    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }

    if (this.pagenationNextToken == null) {
      this.isnextBtn = true;
    }
  }
  async getVehicleByCarID() {
    console.log("Fetching car maintenance data...");
    this.spinnerService.show();  // Show spinner while loading data

    try {
      // Loop through each car and fetch data
      for (let i = 0; i < this.emp_assigned_cars.length; i++) {
        const car_id = this.emp_assigned_cars[i].car_id;
        const car_type = this.emp_assigned_cars[i].ex_data;

        // Fetch data for each car_id
        const response = await this.vehicleService.filterByVehicleID(car_id);

        // Add the fetched items as 'assignedVehicle' for this car
        this.emp_assigned_cars[i] = {
          ...this.emp_assigned_cars[i],
          assignedVehicle: response.items,  // Set 'assignedVehicle' key
          car_type: car_type
        };

        console.log(`Fetched data for car_id ${car_id}:`, response.items);
      }

      console.log("All records with assigned vehicles for each car:", this.emp_assigned_cars);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }
  }


  // async getVehicleByCarID() {
  //   console.log("Fetching car maintenance data...");
  //   this.spinnerService.show();  // Show spinner while loading data

  //   // Temporary array to hold all fetched data
  //   const fetchedData = [];

  //   try {
  //     for (let i = 0; i < this.emp_assigned_cars.length; i++) {
  //       const car_id = this.emp_assigned_cars[i].car_id;

  //       // Fetch data for each car_id
  //       const response = await this.vehicleService.filterByVehicleID(car_id);

  //       // Append fetched items to fetchedData
  //       fetchedData.push(...response.items);
  //       console.log(`Fetched data for car_id ${car_id}:`, response.items);
  //     }

  //     // Update emp_assigned_cars with the accumulated data
  //     this.emp_assigned_cars = [...this.emp_assigned_cars, ...fetchedData];
  //     console.log("All records fetched for assigned vehicles by user:", this.emp_assigned_cars);

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     this.spinnerService.hide();  // Hide the spinner after the process
  //   }
  // }



  rnIdSearch() {
    this.emp_Data = [];
    console.log("searching.....", this.assigncarFm.value.rn_num);
    this.awserviceProvider
      .rnUserFilter(this.assigncarFm.value.rn_num)
      .then((result) => {
        console.log("data-rn-user", result);
        if (result.length === 0) {
          this.errorMessage = "Please Enter Valid RN Number...";
        } else {
          this.errorMessage = "";
          this.emp_Data = result;
          this.getVehicelAssignedCar(result[0].user_name)
          console.log("EMP-data", this.emp_Data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  async getEmpCarDetails() {
    for (var i = 0; i < this.emp_assigned_cars.length; i++) {
      await this.getCarDataById(this.emp_assigned_cars[i].car_id, (result) => {
        this.emp_assigned_cars[i].carDetails = result;
      });
    }
  }

  async getCarDataById(id, callback) {
    console.log("getCarDataById carId", id);
    await this.awserviceProvider
      .carIdFilter(id)
      .then((result) => {
        console.log("car details", result);
        callback(result);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // Modal Open
  constructData(data) {
    data.forEach((item, index) => {
      item.sno = index + 1;
      this.updateCarDetails(item);
    });
  }

  async updateCarDetails(item) {
    await this.awserviceProvider.carIdFilter(item.car_id)
      .then(result => {
        item.car_model = result[0].car_model;
        item.veh_reg_id = result[0].veh_reg_id;
        this.assignCarlist.push(item);

        console.log("Updated Car List:", this.assignCarlist);
      })
      .catch(error => {
        console.error("Error fetching car details:", error);
      });
  }
  // constructData(data) {
  //   data.forEach((item, index) => {
  //     item.sno = index + 1;
  //     this.updateCarDetails(item, index);
  //   });
  // }

  // async updateCarDetails(item, index) {
  //   try {
  //     const result = await this.awserviceProvider.carIdFilter(item.car_id);
  //     item.car_model = result[0].car_model;
  //     item.veh_reg_id = result[0].veh_reg_id;
  //     this.assignCarlist = [...this.assignCarlist, item];
  //   } catch (err) {
  //     console.error("Error fetching car details:", err);
  //   }

  //   console.log("Updated Car List:", this.assignCarlist);
  // }
  // async openStatus(id, data, inx) {
  //   this.car_modal = [];
  //   this.assignCarlist = [];
  //   console.log("::CONSTRUCT_DATE", data);
  //   var oplist = [];
  //   console.log("car-id", id);
  //   await this.awserviceProvider
  //     .carIdFilter(id)
  //     .then((result) => {
  //       console.log("car_details", result);

  //       data[inx]["car_model"] = result[0].car_model;
  //       data[inx]["veh_reg_id"] = result[0].veh_reg_id;
  //       this.assignCarlist = data;
  //       // oplist.push(data[inx]);
  //       //this.car_modal = result;
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  //   //this.assignCarlist = oplist;
  //   console.log("AssignCarlist", this.assignCarlist);
  // }

  // ADD DATA
  add() {
    this.isValid = true;
    this.errorMessage = "";
    this.displayCarValue = 1;
    this.mode = "add";
    this.emp_Data = [];
    this.formInitilization();
    this.getAllCarData();
    this.emp_assigned_cars = [];
    console.log("this.assigncarFm.value", this.assigncarFm.value);
  }

  formInitilization() {
    // this.assigncarFm = new FormGroup({
    //   id: new FormControl(""),
    //   rn_num: new FormControl(""),
    //   assigned_date: new FormControl(""),
    //   end_date: new FormControl(""),
    //   status: new FormControl("ASSIGN"),
    //   car_id: new FormControl("")
    // });
    this.assigncarFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      assigned_date: ["", Validators.required],
      // end_date: ["", Validators.required],
      status: ["ASSIGN"],
      car_id: ["", Validators.required],
      car_name: [""],
      // car_type: ["", Validators.required],
      if_need_fuel_card: [false],
      fuel_card: [""],
      fuel_card_number: [""]
    });
  }

  get f() {
    return this.assigncarFm.controls;
  }

  editformInitilization() {
    console.log("editformInitilization");
    this.assigncarFm = this.formBuilder.group({
      id: [""],
      rn_num: [""],
      end_date: [""],
      assigned_date: ["", Validators.required],
      status: ["", Validators.required],
      car_id: ["", Validators.required],
      car_name: [""],
      // car_type: ["", Validators.required],
      if_need_fuel_card: [false],
      fuel_card: [""],
      fuel_card_number: [""]
    });
  }

  addValidationToFuelCard() {
    if (this.assigncarFm.get('if_need_fuel_card').value) {
      this.assigncarFm.get("fuel_card_number").setValue('');
      this.assigncarFm.get("fuel_card").setValidators([Validators.required]);
    } else {
      this.assigncarFm.get("fuel_card").setValue('');
      this.assigncarFm.get("fuel_card_number").setValue('');
      this.assigncarFm.get("fuel_card").clearValidators();
    }
  }

  editData(car) {
    console.log("car", car);
    this.displayCarValue = 1;
    this.submitted = false;
    this.mode = "edit";
    this.isValid = false;
    this.errorMessage = "";
    this.editformInitilization();
    this.assigncarFm.setValue({
      id: car.id,
      rn_num: car.rn_id,
      assigned_date: car.assigned_date,
      end_date: car.end_date,
      status: car.status,
      car_id: car.car_id,
      // car_type: car.ex_data,
      if_need_fuel_card: car.fuel_card_id ? true : false,
      fuel_card: car.fuel_card_id,
      fuel_card_number: car.fuel_card_id, // If Need edit to find from fuel card array
    });
  }


  onSave() {
    this.submitted = true;
    if (this.assigncarFm.invalid) {
      return;
    }
    // CREATE
    var test1 = {
      user_pid: this.emp_Data[0].id, // user ID
      rn_id: this.emp_Data[0].user_name,
      car_id: this.assigncarFm.value.car_id,
      assigned_date: this.assigncarFm.value.assigned_date,
      status: this.assigncarFm.value.status,
      ex_data: this.unAssignedCarData.find((cardata) => cardata.id == this.assigncarFm.value.car_id).car_type,
      fuel_card_id: this.assigncarFm.value.fuel_card,
    };

    // # CREATE RECORD #
    this.awserviceProvider
      .CreateAssignCar(test1)
      .then((resultData) => {
        // this.getAllData();
        // this.displayCarValue = 0;
        // this.mode = "";
        // this.isValid = true;
        // console.log("update-result", resultData);
        this.updateMasterCarDetails(resultData);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }


  updateMasterCarDetails(resultData) {
    console.log("updateMasterCar", resultData);
    this.awserviceProvider
      .updateMasterCar(resultData)
      .then((result) => {
        console.log("updateMasterCar", result);
        let fuelData = {
          fuel_card_id: this.assigncarFm.value.fuel_card,
          status: this.assigncarFm.value.status,
        }
        if (this.assigncarFm.value.fuel_card) {
          this.updateFuelCardMaster(fuelData);
        } else {
          this.redirectToVDMS();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }


  updateFuelCardMaster(upData) {
    this.awserviceProvider
      .updateFuelCardStatus(upData)
      .then((result) => {
        console.log("updateFuelCardMaster", result);
        this.redirectToVDMS();
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  password() {
    let randomPassword = this.vehicleService.getRandomPassword();
    let encrypt = this.criptoService.encrypt(randomPassword).toString();
    // let decrypt = this.criptoService.decrypt('').toString();
    // console.log(decrypt,encrypt, randomPassword, "Password::::::::::::::::::::::::");
  }
  

  sendEmail() {
    let randomPassword = this.vehicleService.getRandomPassword();
    console.log('::RANDOM PASSWORD::', randomPassword);
    let inputReset = {
      firstname: this.emp_Data[0].name,
      credential: randomPassword,
      emailaddress: this.emp_Data[0].email_address,
      userid: this.emp_Data[0].user_name,
    };
    this.vehicleService.sendResetPasswordEmail(inputReset).subscribe(
      (res) => {
        console.log(res);
        this.enableTemporaryPasswordFlag(inputReset.credential);
      },
      (err: HttpErrorResponse) => {
        console.log('err', err);
        if (err.status == 200) {
          this.enableTemporaryPasswordFlag(inputReset.credential);
        } else {
          console.log("Error While Send Reset Password Email");
          this.redirectToVDMS();
        }
      }
    );
  }

  private enableTemporaryPasswordFlag(password: any) {
    let encrypt = this.criptoService.encrypt(password).toString();
    this.awserviceProvider
      .updateIsTempPassword(this.emp_Data[0].id, encrypt, 'Y')
      .then((response) => {
        console.log(
          '[INFO] ' + ' updatePasswordReset - onResponse: ',
          response
        );
        this.redirectToVDMS();
      })
      .catch((error) => {
        console.log(
          '[INFO] ' + ' updateFirstTimePasswordReset - onError: ',
          error
        );
        this.redirectToVDMS();
      });
  }

  redirectToVDMS() {
    this.router.navigate(['/pages/vdms']);
  }

  // SAVE DATA
  onSubmit() {
    console.log("save btn clicked");
    console.log("onSubmit.....", this.assigncarFm.value);
    this.submitted = true;
    if (this.assigncarFm.invalid) {
      return;
    }
    if (this.assigncarFm.value.id !== "") {
      // UPDATE
      console.log("update");
      var test2 = {
        id: this.assigncarFm.value.id,
        rn_id: this.assigncarFm.value.rn_num,
        car_id: this.assigncarFm.value.car_id,
        assigned_date: this.assigncarFm.value.assigned_date,
        end_date:
          this.assigncarFm.value.end_date === ""
            ? "0"
            : this.assigncarFm.value.end_date,
        status: this.assigncarFm.value.status,
        car_type: this.assigncarFm.value.car_type,
      };
      console.log("test2 .......>", test2);

      // # UPDATE RECORD #
      this.awserviceProvider
        .updateAssignCar(test2)
        .then((result) => {
          this.getAllData();
          this.displayCarValue = 0;
          this.mode = "";
          this.isValid = true;
          console.log("update-result", result);
          this.updateMasterCar(result);
        })
        .catch((err) => {
          console.log("err", err);
        });
      console.log("update-record---", test2);
    } else {
      // CREATE
      var test1 = {
        user_pid: this.emp_Data[0].id, // user ID
        rn_id: this.emp_Data[0].user_name,
        car_id: this.assigncarFm.value.car_id,
        assigned_date: this.assigncarFm.value.assigned_date,

        /*
        end_date:
          this.assigncarFm.value.end_date === ""
            ? "0"
            : this.assigncarFm.value.end_date,
        */
        status: this.assigncarFm.value.status,
        ex_data: this.assigncarFm.value.car_type,
      };
      console.log("test1--", test1);
      // # CREATE RECORD #
      this.awserviceProvider
        .CreateAssignCar(test1)
        .then((resultData) => {
          this.getAllData();
          this.displayCarValue = 0;
          this.mode = "";
          this.isValid = true;
          console.log("resultData-test", resultData);
          this.updateMasterCar(resultData);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }

  updateMasterCar(upData) {
    console.log("updateMasterCar", upData);
    this.awserviceProvider
      .updateMasterCar(upData)
      .then((result) => {
        console.log("updateMasterCar", result);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  // REFER FROM SC-USER-TRIP - (MASTER)
  deleteData(housedt) {
    this.awserviceProvider
      .deleteHouseData(housedt.id)
      .then((res) => {
        this.getAllData();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.displayCarValue = 0;
    this.mode = "";
    this.formInitilization();
    console.log("car data module init");
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }

  // Get All Assigned Cars and update to default car type - 'Office Car'
  /*
  async updateAllAssignedCars() {
    console.log("Get All Assigned Cars");
    await this.awserviceProvider.getAssignCarList().then(async assignCarList => {
      //this.constructData(data.filter(res => res.status === "ASSIGN"));
      console.log("assignCarlist", assignCarList);
      for (var i = 0; i < assignCarList.length; i++) {
        await this.updateAssignedCar(assignCarList[i]);
      }
    });
  }

  async updateAssignedCar(assignedCar) {
    // update Assigned Car
    console.log("------- updateAssignedCar ----------");
    assignedCar.car_type = "Office Car"
    console.log('assignedCar .......>', assignedCar)

    // # UPDATE RECORD #
    await this.awserviceProvider
      .updateAssignCar(assignedCar)
      .then(result => {
        console.log("updated-result", result);
      })
      .catch(err => {
        console.log("err", err);
      });
    console.log("update-record---", assignedCar);
  }
  */


  toggleDropdown(type: number) {
    if (type == 1) {
      this.isDropdownVisible = !this.isDropdownVisible;
    } else if (type == 2) {
      this.isFuelCardDropdownVisible = !this.isFuelCardDropdownVisible
    }
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent) {
    // Check if the clicked element is inside any of the dropdowns
    const clickedInsideSelect = event.target && event.target['closest']('.cus-select-container');
    const clickedInsideFuelCardSelect = event.target && event.target['closest']('.cus-fuel-select-container');

    // Handle the first dropdown (cus-select-container)
    if (!clickedInsideSelect && this.isDropdownVisible) {
      this.isDropdownVisible = false;
      this.unAssignedCarData = JSON.parse(JSON.stringify(this.helperunAssignedCarData));
      this.searchInput.setValue('');
    }

    // Handle the second dropdown (cus-fuel-select-container)
    if (!clickedInsideFuelCardSelect && this.isFuelCardDropdownVisible) {
      this.isFuelCardDropdownVisible = false;
      this.unassignCardData = JSON.parse(JSON.stringify(this.helperunassignCardData));
      this.fuelCardsearchInput.setValue('');
    }
  }

  searchCar(value: any) {
    let carData = JSON.parse(JSON.stringify(this.helperunAssignedCarData));
    this.unAssignedCarData = carData.filter((car: any) => car.veh_reg_id.toLowerCase().includes(value.toLowerCase()));
  }

  setCarValue(id: string) {
    let carData = JSON.parse(JSON.stringify(this.helperunAssignedCarData));
    let details = carData.find((car) => car.id == id);
    this.assigncarFm.get("car_name").setValue(`${details.veh_reg_id} - ${details.car_model} - ${details.car_type}`);
    this.assigncarFm.get("car_id").setValue(id);
    this.isDropdownVisible = false;
    this.unAssignedCarData = carData;
  }


  searchFuelCard(value: any) {
    let cardData = JSON.parse(JSON.stringify(this.helperunassignCardData));
    this.unassignCardData = cardData.filter((card: any) => card.card_number.toLowerCase().includes(value.toLowerCase()));
  }

  setFuelCardValue(id: string) {
    let cardData = JSON.parse(JSON.stringify(this.helperunassignCardData));
    let details = cardData.find((card) => card.id == id);
    this.assigncarFm.get("fuel_card_number").setValue(`${details.card_number}`);
    this.assigncarFm.get("fuel_card").setValue(id);
    this.isFuelCardDropdownVisible = false;
    this.unassignCardData = cardData;
    console.log(this.assigncarFm.value);

  }
}
